<div class="grid-container margin-top margin-bottom-large wrapper">
  <form [formGroup]="form">

    <div class="cell small-12 medium-12 large-12">
      <div class="checkbox">
        @if (hasFieldNotes('hasNoAdditives') || isInReview) {
          <span>
            <view-notes [fieldName]="'hasNoAdditives'" [notes]="getFilteredNotes('hasNoAdditives')" (notesRequested)="handleNotesRequested($event)"></view-notes>
          </span>
        }
        <input class="show-for-sr" id="hasNoAdditives" type="checkbox" formControlName="hasNoAdditives"/>
        <label for="hasNoAdditives">
          No surface hole additives were used. Form 8A not applicable.
          <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
        </label>
      </div>
    </div>

    <div>

      <div class="grid-x grid-margin-x padding-bottom-large section">
        <div class="cell small-12 medium-12 large-12 bold padding-left">
          Download Files:
        </div>
        <div class="cell small-12 medium-12 large-12 padding-left">
          <view-notes [fieldName]="'uploadedFiles'" [notes]="getFilteredNotes('uploadedFiles')" (notesRequested)="handleNotesRequested($event)"></view-notes>
          <upload-view-files [uniqueId]="'uploadedFiles'" [files]="storedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="false" [allowUpload]="false">
          </upload-view-files>
        </div>
      </div>
    </div>
    <hr />

    <label for="receivedDate">Form 8A Received Date</label>
    <view-notes [fieldName]="'receivedDate'" [notes]="getFilteredNotes('receivedDate')" (notesRequested)="handleNotesRequested($event)"></view-notes>
    <common-date-picker [id]="'receivedDate'" (dateUpdated)="onDateUpdated($event, 'receivedDate')" [initialDate]="receivedDate" [disabled]="form?.get('receivedDate')?.disabled"></common-date-picker>


    <div class="grid-x grid-margin-x">
      <div class="large-12 medium-12 small-12 text-align-center">

        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onSave()">Save for Later</button>
          </span>
        }

        @if (!isApproved && !isInCorrections) {
          <span class="minor-margin-right">
            <button class="button" (click)="onAccept()">Accept</button>
          </span>
        }

        <ng-container>
          @if (!isApproved && !isInCorrections) {
            <span class="minor-margin-right">
              <button class="button" (click)="onReturn()">Return For Corrections</button>
            </span>
          }
        </ng-container>
        <span>
          <button class="button" (click)="cancel()">Cancel</button>
        </span>
      </div>


    </div>



  </form>
</div>


